import { forwardRef } from "react";
import type { ElementType, HTMLAttributes, ReactNode } from "react";
import "./Card.css";

export type CardPadding = "none" | "sm" | "md" | "lg";

export interface CardProps extends HTMLAttributes<HTMLElement> {
  padding?: CardPadding;
  /** Adds hover-lift + pointer affordance for cards that act as click targets
   * (e.g. a kanban card or a list item rendered as a Card). */
  interactive?: boolean;
  as?: ElementType;
  children?: ReactNode;
}

export const Card = forwardRef<HTMLElement, CardProps>(function Card(
  { padding = "md", interactive = false, as: Component = "div", className, children, ...rest },
  ref
) {
  const classes = [
    "ui-card",
    `ui-card--pad-${padding}`,
    interactive ? "ui-card--interactive" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Component ref={ref} className={classes} {...rest}>
      {children}
    </Component>
  );
});
